<template>
    <table style="border: 2px solid #CCC;width: 100%;font-size: 10px" border="1" class="table-quick quickTable">
        <tr>
            <td colspan="4" class="cell-quick-reference quick-title">{{this.title}}</td>
            <td colspan="2" class="cell-quick-reference">Maximum System (see Product Sheet for details)</td>
            <td colspan="3" class="cell-quick-reference">Leakage Rate (with low leakage seals)</td>
            <td colspan="3" class="cell-quick-reference"></td>
            <td rowspan="2" style="background-color: #999999;width: 28px; padding-left: 8px;"><div class="cell-quick-reference write-vertical">Product Sheet</div></td>
            <td rowspan="2" style="background-color: #999999;width: 28px;"><div class="cell-quick-reference write-vertical">Specifications<br>CSI</div></td>
            <td rowspan="2" style="background-color: #999999;width: 28px;"><div class="cell-quick-reference write-vertical">Instructions<br>Installation</div></td>
            <td rowspan="2" style="background-color: #999999;width: 28px; padding-left: 8px;"><div class="cell-quick-reference write-vertical">Revit Files</div></td>
        </tr>
        <tr>
            <td class="cell-quick-reference" style="min-width: 75px;cursor: pointer" @click="load('product',0)">Model
                <span style="font-size: 8px" v-if="orders[0] == 'ASC'">▲</span>
                <span style="font-size: 8px" v-if="orders[0] == 'DESC'">▼</span>
            </td>
            <td class="cell-quick-reference" style="cursor: pointer" @click="load('c1',1)">Frame Depth
                <span style="font-size: 8px" v-if="orders[1] == 'ASC'">▲</span>
                <span style="font-size: 8px" v-if="orders[1] == 'DESC'">▼</span>
            </td>
            <td class="cell-quick-reference" style="cursor: pointer;width: 100px;" @click="load('c2',2)">Blade Style
                <span style="font-size: 8px" v-if="orders[2] == 'ASC'">▲</span>
                <span style="font-size: 8px" v-if="orders[2] == 'DESC'">▼</span>
            </td>
            <td class="cell-quick-reference" style="cursor: pointer;width: 180px;" @click="load('c3',3)">Blade Operation
                <span style="font-size: 8px" v-if="orders[3] == 'ASC'">▲</span>
                <span style="font-size: 8px" v-if="orders[3] == 'DESC'">▼</span>
            </td>
            <td class="cell-quick-reference" style="cursor: pointer" @click="load('c4',4)">Pressure (in.wg.)
                <span style="font-size: 8px" v-if="orders[4] == 'ASC'">▲</span>
                <span style="font-size: 8px" v-if="orders[4] == 'DESC'">▼</span>
            </td>
            <td class="cell-quick-reference" style="cursor: pointer" @click="load('c5',5)">Velocity (fpm)
                <span style="font-size: 8px" v-if="orders[5] == 'ASC'">▲</span>
                <span style="font-size: 8px" v-if="orders[5] == 'DESC'">▼</span>
            </td>
            <td class="cell-quick-reference" style="cursor: pointer" @click="load('c6',6)">1 in.wg.
                <span style="font-size: 8px" v-if="orders[6] == 'ASC'">▲</span>
                <span style="font-size: 8px" v-if="orders[6] == 'DESC'">▼</span>
            </td>
            <td class="cell-quick-reference" style="cursor: pointer" @click="load('c7',7)">4 in.wg.
                <span style="font-size: 8px" v-if="orders[7] == 'ASC'">▲</span>
                <span style="font-size: 8px" v-if="orders[7] == 'DESC'">▼</span>
            </td>
            <td class="cell-quick-reference" style="cursor: pointer" @click="load('c8',8)">10 in.wg.
                <span style="font-size: 8px" v-if="orders[8] == 'ASC'">▲</span>
                <span style="font-size: 8px" v-if="orders[8] == 'DESC'">▼</span>
            </td>
            <td class="cell-quick-reference" style="cursor: pointer" @click="load('c9',9)">Flange Frame Option
                <span style="font-size: 8px" v-if="orders[9] == 'ASC'">▲</span>
                <span style="font-size: 8px" v-if="orders[9] == 'DESC'">▼</span>
            </td>
            <td class="cell-quick-reference" style="cursor: pointer" @click="load('c10',10)">304 Stainless Steel Option
                <span style="font-size: 8px" v-if="orders[10] == 'ASC'">▲</span>
                <span style="font-size: 8px" v-if="orders[10] == 'DESC'">▼</span>
            </td>
            <td class="cell-quick-reference" style="cursor: pointer;width: 100px;" @click="load('c11',11)">AMCA CRP Listing
                <span style="font-size: 8px" v-if="orders[11] == 'ASC'">▲</span>
                <span style="font-size: 8px" v-if="orders[11] == 'DESC'">▼</span>
            </td>
        </tr>
        <tr v-for="product in this.data" v-if="product.quickdata">
            <td style="text-align: center;height: 36px"><a :href="`product/details/${product.id}`" target="_blank">{{ product.title }}</a></td>
            <td  v-html="product.quickdata.c1 == '' ? '-':product.quickdata.c1" style="text-align: center"></td>
            <td  v-html="product.quickdata.c2 == '' ? '-':product.quickdata.c2" style="text-align: center"></td>
            <td  v-html="product.quickdata.c3 == '' ? '-':product.quickdata.c3" style="text-align: center"></td>
            <td  v-html="product.quickdata.c4 == '' ? '-':product.quickdata.c4" style="text-align: center"></td>
            <td  v-html="product.quickdata.c5 == '' ? '-':product.quickdata.c5" style="text-align: center"></td>
            <td  v-html="product.quickdata.c6 == '' ? '-':product.quickdata.c6" style="text-align: center"></td>
            <td  v-html="product.quickdata.c7 == '' ? '-':product.quickdata.c7" style="text-align: center"></td>
            <td  v-html="product.quickdata.c8 == '' ? '-':product.quickdata.c8" style="text-align: center"></td>
            <td  v-html="product.quickdata.c9 == '' ? '-':product.quickdata.c9" style="text-align: center"></td>
            <td  v-html="product.quickdata.c10 == 1 ? `<img src='images/check.png'>`:'-'" style="text-align: center"></td>
            <td  v-text="product.quickdata.c11 == '' ? '-':product.quickdata.c11" style="text-align: center"></td>
            <td  v-for="resource in product.resources" v-if="resource.resource_type_id == 3 || resource.resource_type_id == 4 || resource.resource_type_id == 5 || resource.resource_type_id == 6 || resource.resource_type_id == 7">
                <div style="width: fit-content;margin-right: auto;margin-left: auto;cursor:pointer">
                    <a :href="`api/resource/download/${resource.hash}/${product.title}_Product_Sheet`" target="_blank" v-if="resource.resource_type_id == 3">
                        <img src="images/icons/pdf_icon.gif">
                    </a>
                    <a :href="`api/resource/download/${resource.hash}/${product.title}_Specifications_CSI`" target="_blank" v-if="resource.resource_type_id == 4">
                        <img src="images/icons/word_icon.gif">
                    </a>
                    <a :href="`api/resource/download/${resource.hash}/${product.title}_Instructions_Installation`" target="_blank" v-if="resource.resource_type_id == 5 || resource.resource_type_id == 7">
                        <img src="images/icons/pdf_icon.gif">
                    </a>
                    <a :href="`api/resource/download/${resource.hash}/${product.title}_Revit`" target="_blank" v-if="resource.resource_type_id == 6">
                        <img src="images/icons/revit_icon.jpg">
                    </a>
                </div>
            </td>
            <td v-else></td>
            <td  v-if="typeof product.resources === 'undefined'"></td>
            <td  v-if="typeof product.resources === 'undefined'"></td>
            <td  v-if="typeof product.resources === 'undefined'"></td>
            <td  v-if="typeof product.resources === 'undefined'"></td>
        </tr>
    </table>
</template>
<script>
export default {
    props: ['data','title','category'],
    name: 'quick-industrial-control',
    data () {
        return {
            orders: {}
        };
    },
    methods: {
        async load (column,orderType) {
            var order;
            if(this.orders[orderType] == 'ASC' || this.orders[orderType] == '') {
                order = 'ASC';
                this.initOrders();
                this.orders[orderType] = 'DESC';
            }else{
                order = 'DESC';
                this.initOrders();
                this.orders[orderType] = 'ASC';
            }
            const { data } = await axios.get('/api/quickreference/' + this.category + '/' + column + '/' + order);
            this.data = data;
        },
        async initOrders(){
            this.orders = {};
            for(var i = 0;i < 19;i++){
                this.orders.push('');
            }
        }

    },
    watch: {

    },
    async mounted(){
        await this.initOrders();
    }
};
</script>
